import { render, staticRenderFns } from "./NameTableCell.vue?vue&type=template&id=2d82e358&scoped=true"
import script from "./NameTableCell.vue?vue&type=script&lang=js"
export * from "./NameTableCell.vue?vue&type=script&lang=js"
import style0 from "./NameTableCell.vue?vue&type=style&index=0&id=2d82e358&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2d82e358",
  null
  
)

export default component.exports